import * as z from "zod";
import { userFacingError } from "../authorization";
import { grantsForPrincipal } from "../rbac/grantQueries";
import { assertIdpSyncNotActive } from "../rbac/validation";
import { assertNotLastAdmin } from "../rbac/validation/adminGuard";
import { mutator } from "./mutator";

export const deleteInvitedUser = mutator({
  schema: z.object({ userId: z.string() }),
  resolve: {
    target: { kind: "user", from: "userId" },
  },
  permissions: [
    { permission: "tenant:users_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { target } }) => {
    await assertIdpSyncNotActive(tx, ctx.tenantId, "userProvisioning");

    if (target.invitedAt == null || target.lastActiveAt != null) {
      throw userFacingError(
        "Only invited members who have never signed in can be removed"
      );
    }

    await assertNotLastAdmin(tx, ctx.tenantId, target.id);

    const grants = await tx.run(
      grantsForPrincipal({ userId: target.id }, ctx.tenantId)
    );
    for (const grant of grants) {
      await tx.mutate.roleGrants.delete({ id: grant.id });
    }

    await tx.mutate.user.delete({ id: target.id });
  },
});
